import React, {useMemo} from "react";
import "./index.scss";
import {array, bool} from "prop-types";
import Title from "features/components/title";

export const CategoryTagBox = (props) => {
    const {categories, tags, trim = false} = props;

    const cats = useMemo(() => {
        if (!trim) return categories;
        if (categories.length <= 2) return categories;
        return [...categories.slice(0, 2), `+${categories.length - 2}`];
    }, [categories, trim]);
    const trimmed_tags = useMemo(() => {
        if (!trim) return tags;
        if (tags.length <= 2) return tags;
        return [...tags.slice(0, 2), `+${tags.length - 2}`];
    }, [tags, trim]);

    return <div className="category-tag-box">
        {cats.map(i => <div key={i} className="chip category"><Title size={12}>{i}</Title></div>)}
        {trimmed_tags.map(i => <div key={i} className="chip tag"><Title size={12}>{i}</Title></div>)}
    </div>
}
CategoryTagBox.propTypes = {
    categories: array,
    tags: array,
    trim: bool
}